/**
 * German translation for bootstrap-year-calendar
 * Paul DAVID-SIVELLE
 * Based on
 * German translation for bootstrap-datepicker
 * Sam Zurcher <sam@orelias.ch>
 */

(function($) {
  $.fn.calendar.dates["de"] = {
    days: [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag"
    ],
    daysShort: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam"],
    daysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    months: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ],
    monthsShort: [
      "Jan",
      "Feb",
      "Mär",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dez"
    ],
    weekShort: "W",
    weekStart: 1
  };
})(jQuery);



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-availability-calendar/bootstrap-year-calendar.de.js